import { Popconfirm } from "antd";
import React, { useState } from "react";
import { Button } from "reactstrap";
import {
  popButtonDefaultDesc,
  popButtonDefaultIcon,
  popButtonDefaultTitile,
} from "./constant";

function ButtonComponent(props) {
  const {
    popTitle = popButtonDefaultTitile,
    popDescription = popButtonDefaultDesc(""),
    buttonData,
    children,
    onConfirmAction,
    onCancelAction,
    viewPopAction = true,
    okText = "Yes",
    cancelText = "No",
    showCancel = true,
    isOpenPopup = true,
    iconData = popButtonDefaultIcon,
    isViewLoader = true,
    loading = false,
  } = props;

  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => {
    if (!newOpen) {
      setOpen(newOpen);
      return;
    }

    if (!isOpenPopup) {
      onConfirmAction();
    } else {
      setOpen(newOpen);
    }
  };

  const config = {
    open,
    title: popTitle,
    description: popDescription,
    onConfirm: (v) => {
      // setConfirmLoading(true)
      onConfirmAction(v);
    },
    onCancel: onCancelAction || undefined,
    cancelButtonProps: {
      type: "primary",
      color: "danger",
      danger: true,
      loading,
    },
    okText: okText || undefined,
    okButtonProps: { type: "primary", color: "primary", loading },
    cancelText: cancelText || undefined,
    showCancel,
    onOpenChange: !loading ? handleOpenChange : null,
    icon: iconData || null,
    // okButtonProps: {
    //   loading: confirmLoading,
    // }
  };

  const defaultButtonConfig = {
    className: "btn btn-sm",
    color: "primary",
    ...buttonData,
  };

  const buttonConfig = {
    ...defaultButtonConfig,
    onClick: onConfirmAction,
  };

  return viewPopAction ? (
    <Popconfirm {...config}>
      <Button {...defaultButtonConfig}>
        {loading && isViewLoader && (
          <span className="spinner-border spinner-border-sm mt-1 me-2"></span>
        )}
        {children}
      </Button>
    </Popconfirm>
  ) : (
    <Button {...buttonConfig}>
      {loading && isViewLoader && (
        <span className="spinner-border spinner-border-sm mt-1 me-2"></span>
      )}
      {children}
    </Button>
  );
}

export default ButtonComponent;
